import { CSSProperties } from 'react';
import { TooltipProps } from '@/primitives';
import { PUBLIC_ROUTES } from '@/configs/routes';
import { HyperLink } from '@/components/publicSearch/ResultCell/HyperLink';

type TProps = {
  linkStyle?: CSSProperties;
  memberDisplayName: string;
  memberId: number;
  orgName: string;
  tooltipPlacement?: TooltipProps['placement'];
};

export default function MemberInlineDisplay(props: TProps) {
  const pathname = `/${props.orgName}${PUBLIC_ROUTES.MEMBER}/${props.memberId}`;

  return (
    <HyperLink
      label={props.memberDisplayName || 'unknown'}
      linkStyle={props.linkStyle}
      pathname={pathname}
      tooltipPlacement={props.tooltipPlacement ?? 'bottom'}
    />
  );
}
